export const prefix = 'SamlApplication';
export var Scenario;
(function (Scenario) {
    Scenario["Callback"] = "Callback";
    Scenario["AuthnRequest"] = "AuthnRequest";
})(Scenario || (Scenario = {}));
